import { EventSubscriber, EntitySubscriberInterface, InsertEvent, UpdateEvent } from 'typeorm'

import { HistoryEntitySubscriber } from '@operato/typeorm-history'
import { pubsub, getRepository } from '@things-factory/shell'

import { Board } from './board.js'
import { BoardHistory } from './board-history.js'

@EventSubscriber()
export class BoardSubscriber implements EntitySubscriberInterface<Board> {
  listenTo() {
    return Board
  }

  async beforeUpdate(event: UpdateEvent<Board>): Promise<any> {
    var board = event.entity

    if (!board.version) {
      board.version = 0
    }
  }

  async afterUpdate(event: UpdateEvent<Board>): Promise<any> {
    var board = event.entity

    board = await event.manager.findOne(Board, {
      where: { domain: { id: board.domainId }, id: board.id },
      relations: ['playGroups']
    })

    if (!board || board.state != 'released') {
      return
    }

    board.playGroups.forEach(playGroup =>
      pubsub.publish('play-group', {
        playGroup
      })
    )

    pubsub.publish('board', {
      board
    })
  }
}

@EventSubscriber()
export class BoardHistoryEntitySubscriber extends HistoryEntitySubscriber<Board, BoardHistory> {
  public get entity() {
    return Board
  }

  public get historyEntity() {
    return BoardHistory
  }

  // release 시 releaseBoard 가 넣어준 entity.__releaseComment 를 history.comment 로 주입한다(Board 컬럼 아님).
  public beforeInsertHistory(history: BoardHistory, entity: Board): BoardHistory {
    ;(history as any).comment = (entity as any).__releaseComment ?? null
    return history
  }

  public beforeUpdateHistory(history: BoardHistory, entity: Board): BoardHistory {
    ;(history as any).comment = (entity as any).__releaseComment ?? null
    return history
  }

  public async afterInsert(event): Promise<void> {
    if (event.entity.state == 'released') {
      await super.afterInsert(event as any)
    }
  }

  public async afterUpdate(event): Promise<void> {
    if (event.entity.state == 'released') {
      await super.afterUpdate(event as any)
    }
  }
}
